import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DMSanPhamService {
    controller: string = 'DM_SanPham';
    constructor(
        private http: Http
    ) { }
    GetList_DM(paging: number, maxSize: number, keyword: string, idnhomsanpham: number, idloaicoquan: number, idcoquan: number) {
        let headers = new Headers();
        let currentPage = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetList_DM?offset=" + currentPage + "&pageSize=" + maxSize + "&keyword=" + keyword + "&idnhomsanpham=" + idnhomsanpham + "&idloaicoquan=" + idloaicoquan + "&idcoquan=" + idcoquan, { headers: headers }).map(resp => resp.json());
        
    }
    GetListSort(idnhomsanpham: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetListSort?idnhomsanpham=" + idnhomsanpham, { headers: headers }).map(resp => resp.json());        
    }
    GetList_SP(paging: number, maxSize: number, keyword: string, idnhomsanpham: number, idloaicoquan: number, idcoquan: number) {
        let headers = new Headers();
        let currentPage = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetList_SP?offset=" + currentPage + "&pageSize=" + maxSize + "&keyword=" + keyword + "&idnhomsanpham=" + idnhomsanpham + "&idloaicoquan=" + idloaicoquan + "&idcoquan=" + idcoquan, { headers: headers }).map(resp => resp.json());
    }
    GetList(paging: number, maxSize: number, keyword: string, idloaithietbi: number, idcoquan: number) {
        let headers = new Headers();
        let currentPage = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetList?offset=" + currentPage + "&pageSize=" + maxSize + "&keyword=" + keyword + "&idloaithietbi=" + idloaithietbi + "&iddonvi=" + idcoquan, { headers: headers }).map(resp => resp.json());
    }
    GetListCoQuanCon(idcoquan: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetListCoQuanCon?&idcoquan=" + idcoquan, { headers: headers }).map(resp => resp.json());
    }
    GetListDieuHanh(idcoquan: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetListDieuHanh?&idcoquan=" + idcoquan, { headers: headers }).map(resp => resp.json());
    }
    Save(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller + '/Save_DM', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    CheckTrungTen(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller + '/CheckTenTrung', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    SaveDungChung(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller + '/Save_DungChung', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(item) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller + '/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ThongSoKyThuatSanPham(TSKTSP) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TSKTSP;
        return this.http.post(Config.apiUrl + 'ThongSoKyThuatSanPham/DanhSach_ThongSoKyThuatSanPham', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_ThongSoKyThuatSanPham(TSKTSP) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TSKTSP;
        return this.http.post(Config.apiUrl + 'ThongSoKyThuatSanPham/Tao_ThongSoKyThuatSanPham', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Huy_ThongSoKyThuatSanPham(TSKTSP) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TSKTSP;
        return this.http.post(Config.apiUrl + 'ThongSoKyThuatSanPham/Huy_ThongSoKyThuatSanPham', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListQT(IdCoQuan: number, IdQuyTrinh: number, nangcap: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetList_QT?idcoquan=" + IdCoQuan + "&idquytrinh=" + IdQuyTrinh + "&nangcap=" + nangcap, { headers: headers }).map(resp => resp.json());
    }
    GetListNoYC(IdCoQuan: number, IdNhomSanPham: number, IdSanPham:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetListQTYC?idcoquan=" + IdCoQuan + "&IdNhomSanPham=" + IdNhomSanPham+ "&IdSanPham=" + IdSanPham, { headers: headers }).map(resp => resp.json());
    }
    addCoQuan(IdSanPham: number, ListCoQuan: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl + this.controller + '/addCoQuanSuDung?IdSanPham=' + IdSanPham, JSON.stringify(ListCoQuan), {
            headers: headers
        }).map(resp => resp.json())
    }
    addUser(ListCoQuan: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl + this.controller + '/addUserSMS', JSON.stringify(ListCoQuan), {
            headers: headers
        }).map(resp => resp.json())
    }
    DanhSach_NhomSuCo(SPNSC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = SPNSC;
        return this.http.post(Config.apiUrl + 'DM_NhomSuCo/DanhSach_NhomSuCo', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_SanPhamNhomSuCo(SPNSC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = SPNSC;
        return this.http.post(Config.apiUrl + 'DM_NhomSuCo/Luu_SanPhamNhomSuCo', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_SanPham_NhomSuCo(IdCoQuan, IdNhomSuCo, keyword) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdCoQuan: IdCoQuan, IdNhomSuCo: IdNhomSuCo};
        return this.http.post(Config.apiUrl + 'DM_SanPham/GetList_SP_NSC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_SanPham_User() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DM_SanPham/GetList_SP_User', { headers: headers }).map(resp => resp.json());
    }
    Tao_SanPham_NhomSuCo(NSCSP) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = NSCSP;
        return this.http.post(Config.apiUrl + 'DM_NhomSuCo/Save_SanPham_NhomSuCo', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sanpham/dm-san-pham/dm-san-pham.service.ts